module.exports = __webpack_public_path__ + "img/20201216_125523.0824b6d3.jpg";